module.exports = __webpack_public_path__ + "static/media/mod_cod4_surf_3.72b4cbcf.jpg";